/* eslint-disable no-unused-vars */


import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';

import { get_event_details } from '../../store/reducers/eventDetailsReducer';

import { GrGallery } from "react-icons/gr";

import GetSellerConfig from '../GetSellerConfig';

const MyGallery = () => {

    const { userInfo } = useSelector((state) => state.auth);
    const { eventDetails } = useSelector((state) => state.eventDetails);
    const dispatch = useDispatch();
    
    useEffect(() => {
        if (userInfo?.id) {
        dispatch(get_event_details(userInfo.id));
        }
    }, [dispatch, userInfo?.id]);

    const {
        sellerColorDark, sellerColorMedium, sellerColorLight,
        //sellerPrimaryColor1, sellerSecondaryColor1, sellerColorSuffixDark,
        //sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor, sellerShopName, 
    } = GetSellerConfig();
    
    return (
        <div className="bg-white rounded-2xl">
            <div className="p-4 rounded-2xl border"
                style={{
                    backgroundColor: sellerColorLight,
                    borderColor: sellerColorDark,
                }}>
                <div
                    className='grid grid-cols-2 md-lg:grid-cols-2 md:grid-cols-1'>
                    <div className='flex items-center gap-1 mb-1 pb-1'>
                        <div>
                            <GrGallery size={48} style={{ color: sellerColorDark }} />
                        </div>
                        <div>
                            <div
                                className="text-2xl font-bold tracking-tight leading-none"
                                style={{ color: sellerColorDark }}>
                                My Gallery
                            </div>
                            <div className="text-md mt-0.5" style={{ color: sellerColorMedium }}>
                                Welcome Your Guests To Your Simcha / Party
                            </div>
                        </div>
                    </div>
    
                    <div className='flex items-start gap-3'>
                        <button className='gap-1 m-1 rounded-xl px-3 py-1 flex ml-auto md:ml-0' style={{backgroundColor: sellerColorDark }}>
                            <Link to='/galleryImages' 
                            className='flex p-2 gap-2 text-[20px] w-[160px] h-[40px] items-center justify-center  text-white'>
                            <GrGallery size={24} /> Edit Gallery
                            </Link>
                        </button>
                    </div>
                </div>
                
                <div className='gap-3 mb-4 mt-4'>
                    {(() => {
                        const savedGalleryImages = eventDetails?.selectedGalleryImages
                            ? JSON.parse(eventDetails.selectedGalleryImages)
                            : [];
                        return savedGalleryImages.length > 0 ? (
                            <div className="grid grid-cols-4 sm:grid-cols-2 gap-2">
                                {savedGalleryImages.map((item) => (
                                    <div key={item.id}
                                        className="p-0 border rounded-xl"
                                        style={{ 
                                            borderColor: sellerColorDark,
                                            borderTopWidth: '6px',
                                        }}>
                                        <div className="flex flex-col items-center">
                                            <img src={item.image} alt={item.name}
                                            style={{
                                                borderRadius: "8px 8px 0px 0px",
                                            }} />
                                            <div className="w-full px-2 py-1 text-center text-[13px] font-medium"
                                                style={{ 
                                                    color: sellerColorDark,
                                                    backgroundColor: sellerColorLight 
                                                }}>
                                                {item.name}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p className="italic font-normal text-[13px]" style={{ color: sellerColorMedium }}>
                                {/*No saved settings found.*/}
                            </p>
                        );
                    })()}
                </div>
                                                
            </div>
            
        </div>
    );
};

export default MyGallery;
